import React from 'react';
import Expo from 'expo';
import { Link } from './link';
import { isWeb } from './platform';
import { I18nManager } from 'react-native';
import { style } from 'constants';
import { setDefaultLang, lang } from 'lang';

const styles = style({
    holder: {
        borderWidth: 1,
        borderRadius: 23,
        height: 48,
        width: 48,
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'flex-end',
        margin: 30
    }
});

export const SwitchLang = ({ self, style, ...props }) =>
    true ? (
        <Link
            title={lang.ALTER_LANG_NAME}
            style={[styles.holder, style]}
            size={10}
            {...props}
            onPress={() => {
                const toggleRTL = !I18nManager.isRTL;
                //I18nManager.allowRTL(toggleRTL)
                I18nManager.forceRTL(toggleRTL);
                //I18nManager.setPreferredLanguageRTL(toggleRTL)
                setDefaultLang(toggleRTL ? 'ar' : 'en');
                self && self.forceUpdate();
                isWeb && (document.title = lang.FOSOL);
                //Expo.Util && Expo.Util.reload();
                Expo.Updates && Expo.Updates.reloadFromCache();
            }}
        />
    ) : null;



// WEBPACK FOOTER //
// ./src/components/core/switch_lang.js